module.exports = __webpack_public_path__ + "components/page-header/static/icon-heart-fill-8ddc2e5818a3a90149224a9375543355.svg";